export default "__VITE_ASSET__ea2bc5f7__"